import { logUsage } from 'owa-analytics';
import { AttachmentFile, AttachmentFileType } from 'owa-attachment-file-types';
import { ITEM_ID_ATTACHMENT_TYPE } from 'owa-attachment-type-constants';
import {
    lazyCreateCloudFileFromAttachmentData,
    ReplyWithAttachmentSuggestion,
    ReplyWithEndpointType,
} from 'owa-attachment-suggestions';
import { ClientAttachmentId } from 'owa-client-ids';
import { ComposeViewState } from 'owa-mail-compose-store';
import createAttachments from 'owa-mail-compose-actions/lib/utils/createAttachments';
import { lazyShowInsertLinkTeachingMoment } from 'owa-compose-ribbon';

export async function onAttachmentClicked(
    suggestion: ReplyWithAttachmentSuggestion,
    suggestionIndex: number,
    composeViewState: ComposeViewState
): Promise<void> {
    if (
        suggestion.Endpoint === ReplyWithEndpointType.MRUClassic ||
        suggestion.Endpoint === ReplyWithEndpointType.MRUClassicContextual
    ) {
        const attachmentId: string = suggestion.Id;

        const attachmentFile: AttachmentFile = {
            fileType: AttachmentFileType.AttachmentItemSuggestion,
            name: suggestion.FileName,
            size: parseInt(suggestion.FileSize),
            attachmentItemId: attachmentId,
            type: ITEM_ID_ATTACHMENT_TYPE,
        };

        createAttachments(
            [attachmentFile],
            composeViewState,
            {
                isInline: false,
                isHiddenInline: false,
                shouldShare: false,
            },
            null /* infoBar */,
            (attachmentId: ClientAttachmentId) =>
                onAttachmentUploaded(attachmentId.Id, suggestion, suggestionIndex)
        );
    } else {
        const createCloudFileFromAttachmentData = await lazyCreateCloudFileFromAttachmentData.import();
        await createCloudFileFromAttachmentData(suggestion, cloudFile => {
            createAttachments(
                [cloudFile] /* files */,
                composeViewState,
                {
                    isInline: false,
                    isHiddenInline: false,
                    shouldShare: true,
                    isAddedFromSmartDoc: false,
                },
                null /* onAllAttachmentsProcessed */,
                (attachmentId: ClientAttachmentId) =>
                    onAttachmentUploaded(
                        attachmentId.Id,
                        suggestion,
                        suggestionIndex
                    ) /* onAttachmentCreatedCallback */,
                null /* onAttachmentCanceledOrFailedCallback */,
                null /* tryAgainCallback */
            );
        });
    }
}

export async function onAttachmentUploaded(
    generatedAttachmentId: string,
    suggestion: ReplyWithAttachmentSuggestion,
    suggestionIndex: number
): Promise<void> {
    lazyShowInsertLinkTeachingMoment
        .import()
        .then(showInsertLinkTeachingMoment => showInsertLinkTeachingMoment(false));
    // AttachmentSuggestionClicked is unsampled and cosmos only
    // for accurate scorecard reporting
    logUsage(
        'AttachmentSuggestionClicked',
        [
            suggestion.Endpoint,
            suggestion.Id,
            suggestionIndex,
            suggestion.FileSourceType,
            suggestion.FileExtension,
            generatedAttachmentId,
            suggestion.TraceId,
        ],
        { isCore: true, isCosmosDatapoint: true }
    );

    // AttachmentSuggestionClickedSampled is sampled and will be stored in Kusto
    // for quick detecting of problem
    logUsage('AttachmentSuggestionClickedSampled', {
        position: suggestionIndex,
        traceId: suggestion.TraceId,
    });
}
